export interface HudThemeStatistic {
  hudThemeId: number;
  hudThemeName?: string;
  vpipPercentage: number;
  prfPercentage?: number;
  threeBetPercentage?: number;
  foldThreeBetPercentage?: number;
  fourBetPercentage?: number;
  stealPercentage?: number;
  checkRaisePercentage?: number;
  cBetPercentage?: number;
  foldToCBetPercentage?: number;
  wsdPercentage?: number;
  wtsdPercentage?: number;
  totalHands?: number;
}

export interface PlayerHudStatistic extends HudThemeStatistic {
  playerId: number;
}

export interface TableHudStatistic {
  tableId: number;
  hudStatsPerPlayers: PlayerHudStatistic[];
}

export function normalizeHudThemeStatistics(rawStats: any[]): HudThemeStatistic[] {
  return (rawStats || []).map((stat: any) => ({
    hudThemeId: stat.hudThemeId ?? stat.HudThemeId,
    hudThemeName: stat.hudThemeName ?? stat.HudThemeName,
    vpipPercentage: stat.vpipPercentage ?? stat.VpipPercentage ?? 0,
    prfPercentage: stat.prfPercentage ?? stat.PrfPercentage ?? 0,
    threeBetPercentage: stat.threeBetPercentage ?? stat.ThreeBetPercentage ?? 0,
    foldThreeBetPercentage:
      stat.foldThreeBetPercentage ?? stat.FoldThreeBetPercentage ?? 0,
    fourBetPercentage: stat.fourBetPercentage ?? stat.FourBetPercentage ?? 0,
    stealPercentage: stat.stealPercentage ?? stat.StealPercentage ?? 0,
    checkRaisePercentage:
      stat.checkRaisePercentage ?? stat.CheckRaisePercentage ?? 0,
    cBetPercentage: stat.cBetPercentage ?? stat.CBetPercentage ?? 0,
    foldToCBetPercentage:
      stat.foldToCBetPercentage ?? stat.FoldToCBetPercentage ?? 0,
    wsdPercentage: stat.wsdPercentage ?? stat.WsdPercentage ?? 0,
    wtsdPercentage: stat.wtsdPercentage ?? stat.WtsdPercentage ?? 0,
    totalHands: stat.totalHands ?? stat.TotalHands ?? 0,
  }));
}
